module.exports = __webpack_public_path__ + "img/logo.ef7eed6a.svg";